<template>
  <div :class="{'nav-horizontal': navMenuModeIsHorizontal, 'nav-left': userRole === 4}">
    <!--  :background-color="navMenuModeIsHorizontal?'#2196f3':'#ffffff'" :text-color="navMenuModeIsHorizontal?'#ffffff':'#909399'" :active-text-color="navMenuModeIsHorizontal?'#ffd04b':'#2196f3'" -->
    <el-menu :default-active="activePath" router :class="{'el-menu-vertical': !navMenuModeIsHorizontal}" :collapse="isCollapse" :mode="navMenuModeIsHorizontal ? 'horizontal' : 'vertical'" @select="handleSelect">
      <el-menu-item v-for="(item,index) in projectMenu" :key="index" :index="`${index}`" :route="item.index" v-if="!item.childrens">
        <i v-if="!navMenuModeIsHorizontal" :class="item.icon"></i>
        <span slot="title">{{item.title === 'user' ? $t(`manage.title`) : item.title === 'label' ? $t(`label.title`) : item.title === 'order' ? $t(`order.title`) : '测试'}}</span>
      </el-menu-item>
      <el-submenu v-for="(item,index) in projectMenu" :index="`${index}`" :key="index" v-if="item.childrens">
        <template slot="title">
          <i v-if="!navMenuModeIsHorizontal" :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </template>
        <div v-for="(v,i) in item.childrens" :key="i">
          <el-menu-item :index="`${index}-${i}`" :route="v.index">{{v.title}}</el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import { ZWSProject } from '@/native/ZWSProject.js'
export default {
  props: {
    navMenuModeIsHorizontal: {
      type: Boolean,
      default: true
    },
    isCollapse: {
      type: Boolean
    }
  },
  data () {
    return {
      projectMenu: [],
      activePath: '0',
      userRole: JSON.parse(localStorage.getItem('zlg_label_userinfo')).role
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.activePath = key
      localStorage.setItem('zlg_label_nav_active', key)
    }
  },
  created () {
    this.activePath = localStorage.getItem('zlg_label_nav_active') || '0'
    if (this.userRole === 4) {
      let userinfo = JSON.parse(localStorage.getItem('zlg_label_userinfo'))
      this.projectMenu =  userinfo.username === 'admin'
        ? [
          {icon: 'el-icon-user-solid', title: 'user', index: '/Home/Manage/ManageList'},
          {icon: 'el-icon-menu', title: 'label', index: '/Home/Label/LabelList'}
          // {icon: 'el-icon-question', title: '测试', index: '/Home/Test/Test'}
        ]
        : [{icon: 'el-icon-menu', title: 'label', index: '/Home/Label/LabelList'}]
      if (this.activePath === '0' && userinfo && userinfo.username === 'admin') {
        this.$router.push('/Home/Manage/ManageList')
      } else {
        this.$router.push('/Home/Label/LabelList')
      }
    } else {
      this.projectMenu = [
        {icon: 'el-icon-s-order', title: 'order', index: '/Home/Order/OrderList'},
        {icon: 'el-icon-menu', title: 'label', index: '/Home/Label/LabelList'},
        // {icon: 'el-icon-question', title: '测试', index: '/Home/Test/Test'}
      ]
      if (this.activePath === '0') {
        this.$router.push('/Home/Order/OrderList')
      } else {
        this.$router.push('/Home/Label/LabelList')
      }
    }
  }
}
</script>
<style lang="less">
.nav-horizontal {
  position: fixed;
  top: 60px;
  z-index: 9;
  width: 100%;
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ccdbee;
  box-shadow: 0px 1px 3px #edf2f5;
  -moz-box-shadow: 0px 1px 3px #edf2f5;
  ul {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  ul li span {
    font-size: 16px;
    font-weight: bold;
  }
}
// .nav-left {
//   ul {
//     transform: translateX(-580px);
//     -ms-transform: translateX(-580px);
//     -moz-transform: translateX(-580px);
//   }
// }
.el-menu {
  border: none !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom-width: 2px !important;
    color: #8fc41e !important;
    border-bottom: 2px solid #8fc41e;
}
.el-menu--horizontal>.el-menu-item {
  color: #262626 !important;
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/HomeModule/Container/ZWSAside.vue